var flag_setCookieAccepted = true;

function setCookieAccepted(value, duration) {

    if (typeof duration == 'undefined' || !duration) {
        duration = 90;
    }
    if (typeof value == 'undefined' || !value) {
        value = [];
        value.push({name: 'cookie1'});
        value.push({name: 'cookie2'});
        value.push({name: 'cookie3'});
        value.push({name: 'cookie4'});
        value.push({name: 'cookie5'});
    }

    // console.log(value);

    if (value.length < 5) {
        for (var i = 1; i <= 5; i++) {
            eraseCookie('cookie_law_accepted_cookie'+i);
        }
    }

    var valuesArray = [];
    for (var i = 0; i < value.length; i++) {
        valuesArray.push(value[i].name);
        setCookie('cookie_law_accepted_'+value[i].name, true, duration);
        dataLayer.push({'event': 'cookie_law_accepted_'+value[i].name});
        // console.log(valuesArray);
    }
    // always set cookie1 (technical cookies)
    setCookie('cookie_law_accepted_cookie1', true, duration);

    // check cookie non accettati
    if (value.length < 5) {
        if (!valuesArray.includes('cookie2')) {
        }
        if (!valuesArray.includes('cookie3')) {
        }
        if (!valuesArray.includes('cookie4')) {
            // analytics
            document.cookie = '_gid' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = '_ga' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
        if (!valuesArray.includes('cookie5')) {
            // pixel, remarketing
            document.cookie = '_fbp' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    }

    flag_setCookieAccepted = false;
}